import React from 'react';
import {
  AgFinancingFile,
  AgOpportunity,
  AgOrderInfo,
  FinancingBrazilGrowerLeadAdditionalInfo
} from '@indigo-ag/schema';
import { Body } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { DocumentCard, PhaseSection, utils, GridContainer, GridContainerItem } from 'shared';

export interface ContractDataSectionProps {
  contractFile?: AgFinancingFile;
  opportunity?: AgOpportunity;
  campaign?: AgOrderInfo['campaign'];
  contractAddress?: FinancingBrazilGrowerLeadAdditionalInfo['mailingAddress'];
}

export const ContractDataSection: React.FunctionComponent<ContractDataSectionProps> = ({
  contractFile,
  opportunity,
  campaign,
  contractAddress
}) => {
  const items: GridContainerItem[] = [
    {
      label: utils.text.toTitleCase(i18next.t('contractAddress')),
      value: contractAddress
    },
    {
      label: i18next.t('contractValue'),
      value: opportunity?.contractValue
        ? utils.currency.inputMaskCurrency(opportunity.contractValue, {
            useComaForDecimals: true
          })
        : undefined
    },
    {
      label: i18next.t('emissionDate'),
      value: opportunity?.contract?.startDate
        ? utils.date.format({ date: opportunity.contract.startDate, useUTC: true })
        : undefined
    },
    {
      label: i18next.t('cvExpirationDate'),
      value: opportunity?.dueDate ? utils.date.format({ date: opportunity.dueDate, useUTC: true }) : undefined
    },
    {
      label: i18next.t('campaign'),
      value: campaign
    },
    {
      label: i18next.t('products'),
      value: opportunity?.products ? opportunity.products.join(', ') : undefined
    },
    {
      label: i18next.t('commercialRepresentative'),
      value: opportunity?.responsible
    }
  ];

  return (
    <PhaseSection title={i18next.t('contract')}>
      <div className="flex">
        {contractFile ? (
          <DocumentCard document={contractFile} />
        ) : (
          <Body>{utils.text.firstLetterUppercase(i18next.t('noContractMessage'))}</Body>
        )}
      </div>
      <GridContainer columns={4} items={items} classes={{ container: 'mt-4' }} />
    </PhaseSection>
  );
};
